import { Button } from "@blueprintjs/core"
import { useCallback } from "react"
import { hideMobileMap } from "@/reducers/overlaysSlice"
import { mobileRoutes, updateMobileRoute } from "@/routes/routes"
import { useAppDispatch } from "@/reducers/hooks"
import { useTranslation } from "react-i18next"

const CloseMobileMap = ({ onClose }: { onClose?: () => void }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const closeMobileMap = useCallback(() => {
    dispatch(hideMobileMap())
    if (onClose) {
      updateMobileRoute(mobileRoutes.CHAT_LIST)
    } else {
      updateMobileRoute(mobileRoutes.CHAT)
    }
    onClose?.()
  }, [dispatch, onClose])

  return (
    <div
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        zIndex: 10,
      }}
    >
      <Button
        onClick={closeMobileMap}
        icon="cross"
        className="dark:bg-gray-700 dark:text-white"
        title={t("maps.closeMobileMap.title")}
      />
    </div>
  )
}

export default CloseMobileMap
